export const getEstabLandingPageUrl = (hotelId, queryString) => {
    const pageUrl = `/2-${hotelId}-1`;
    return `${pageUrl}${queryString !== null && queryString !== void 0 ? queryString : ''}`;
};
